"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const app_1 = require("./app");
const getUsers_1 = require("./getUsers");
const updateUser_1 = require("./updateUser");
function addUser(userObj) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { name, email, providerIds, permissions, googleAuthRefreshToken = null, password } = userObj;
            const usersRef = app_1.app.firestore.collection(`users`);
            const usersDoc = yield getUsers_1.default({ email });
            const insertObj = {
                name,
                email,
                providerIds,
                permissions,
                password,
                googleAuthRefreshToken
            };
            if (!usersDoc.length) {
                const response = yield usersRef.add(insertObj);
                return Object.assign({}, userObj, { id: response.id, alreadyExists: false });
            }
            else {
                console.log('User with given email id already exists in users collection. Email : ', email);
                // throw `User with given email id already exists. Email : ${email}`;
                return yield updateUser_1.default(usersDoc[0].id, {
                    name,
                    providerIds,
                    permissions,
                    googleAuthRefreshToken
                });
            }
        }
        catch (e) {
            console.log('Error adding user: ', e.message);
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, 'Error while adding user', e.message);
        }
    });
}
exports.default = addUser;
//# sourceMappingURL=addUser.js.map